import styled from "@emotion/styled";

import CommentIcon from "./comment-widget-icon.svg";

type Props = {
  $hasComment: boolean;
};
export const StyledButton = styled.button<Props>`
  position: relative;

  inline-size: 20px;
  block-size: 20px;
  margin-inline-end: ${props => (props.$hasComment ? "10px" : "0")};
  padding: 0;

  border: none;

  background-color: transparent;

  cursor: pointer;
`;

export const Icon = styled(CommentIcon)`
  inline-size: 100%;
  block-size: 100%;
`;

export const CountMessage = styled.span`
  position: absolute;
  inset-block-start: -6px;
  inset-inline-start: 12px;

  display: flex;
  flex-flow: row;
  justify-content: center;
  align-items: center;

  min-inline-size: 16px;
  margin-inline-end: 10px;
  padding: 2px;

  color: #ffffff;
  font-size: 12px;
  line-height: 14px;

  border-radius: 2px;

  background-color: #eb4254;
`;
